<template>
  <div>
    <populate-form
      formTitle="例外休息時段維護"
      fkey="pe01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
    ></populate-form>
    <b-table
      stacked="sm"
      :items="restTimeInstances"
      :fields="fields"
    >
      <template slot="actions" slot-scope="row">
        <b-button @click="removeRestTimeInstance(row.item.id)">刪除</b-button>
      </template>
    </b-table>
    <b-modal
      v-model="modalShowAdd" 
      centered
      hide-header
      hide-footer
      :static="true"
    >
      <populate-form
        formTitle="新增自訂休息時段"
        fkey="arf01"
        ref="addForm"
        :parentVue="this"
        populateOptionVar="addOptions"
        formDataObjVar="addData"
      ></populate-form>
    </b-modal>
    <b-modal
      v-model="modalShowRule" 
      centered
      hide-header
      hide-footer
      :static="true"
    >
      <StoreRestTimeRuleManage></StoreRestTimeRuleManage>
    </b-modal>
  </div>
</template>

<script>

import StoreRestTimeRuleManage from "./SubComponent/StoreRestTimeRuleManage"

export default {
  name: 'StoreRestTimeManage',
  components:{
    StoreRestTimeRuleManage,
  },
  props: {
    
  },
  data: function () {
    return {
      modalShowAdd:false,
      modalShowRule:false,
      service_minute_unit:30,
      restTimeInstances:[],
      fields:[
        {
          key:'src',
          label:'來源'
        },
        {
          key:'resttime_start',
          label:'休息開始'
        },
        {
          key:'resttime_end',
          label:'休息結束'
        },
        {
          key:'remark',
          label:'說明'
        },
        {
          key:'created_time',
          label:'建立時間'
        },
        {
          key:'actions',
          label:'操作'
        },
      ],
      filterData:{},
      filterOptions:[
        {
          componentType:'date-picker',
          akey:'from_date',
          defaultValue:'',
          col:2,
          placeholder:'篩選起始日'
        },
        {
          componentType:'date-picker',
          akey:'to_date',
          defaultValue:'',
          col:2,
          placeholder:'篩選結束日'
        },
        {
          componentType:'btn-group',
          col:8,
          buttons:[
            {
              col:2,
              placeholder:'篩選',
              execCallback:this.searchRestInstance
            },
            {
              col:3,
              placeholder:"手動新增",
              execCallback:this.showAddRest
            },
            {
              col:3
            },
            {
              col:3,
              placeholder:"規則管理",
              execCallback:this.showManageRule
            }
          ]
        },
      ],
      addData:{},
      addOptions:[
        {
          componentType:'date-picker',
          akey:'resttime_date',
          col:4,
          placeholder:"休息日期"
        },
        {
          componentType:'vue-timepicker',
          col:4,
          akey:'start_time',
          placeholder:"選擇開始時間",
          defaultValue:"",
          minuteInterval:this.service_minute_unit,
          minHour:0,
          maxHour:23,
        },
        {
          componentType:'vue-timepicker',
          col:4,
          akey:'end_time',
          placeholder:"選擇結束時間",
          defaultValue:"",
          minuteInterval:this.service_minute_unit,
          minHour:0,
          maxHour:23,
        },
        {
          componentType:'text',
          akey:'remark',
          col:12,
          placeholder:"休息原因說明",
          defaultValue:''
        },
        {
          componentType:'span',
          col:4,
        },
        {
          componentType:'b-button',
          col:4,
          placeholder:'確認',
          execCallback:this.confirmAdd
        },
        {
          componentType:'span',
          col:4,
        },
      ],
    }
  },
  methods: {
    showAddRest() {
      this.addData.resttime_date = ''
      this.addData.start_time = ''
      this.addData.end_time = ''
      this.addData.remark = ''
      this.$refs.addForm.initDefault()
      this.modalShowAdd = true
    },
    showManageRule() {
      this.modalShowRule = true
    },
    removeRestTimeInstance(id) {
      this.$bus.fnShowConfirm("確認要刪除嗎?", () => {
        let Param = {
          'module':'store',
          'method':'cancelStoreCustomResttime',
          'store_id': this.$bus.session.merchant_store_id,
          'instance_id':id,
        }
        this.$bus.apiCall(Param, function (data, vm) {
          if (data.ok === 0) {
              if (!data.data.confirm_remove) {
                vm.$bus.fnClosePopup()
                vm.$bus.fnShowInfo(data.msg)
                return
              }
            }
          vm.$bus.fnClosePopup()
          vm.$bus.fnShowInfo("刪除完成")
          vm.searchRestInstance()
        }, this)
      })
    },
    searchRestInstance() {
      let Param = {
        'module':'store',
        'method':'getStoreCustomRestTimes',
        'store_id': this.$bus.session.merchant_store_id,
        'filter_date_s':this.filterData.from_date?this.filterData.from_date:'',
        'filter_date_e':this.filterData.to_date?this.filterData.to_date:'',
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        vm.restTimeInstances =data.data
      }, this)
    },
    confirmAdd() {
      if (!this.addData.resttime_date) {
        this.$refs.addForm.triggerAlert('休息日期不正確')
        return
      }
      if (!this.addData.start_time || !this.addData.end_time) {
        this.$refs.addForm.triggerAlert('休息時間未選擇完成')
        return
      }
      if (this.addData.start_time > this.addData.end_time) {
        this.$refs.addForm.triggerAlert('休息時間起訖錯誤')
        return
      }
      if (!this.addData.remark) {
        this.$refs.addForm.triggerAlert('請留下自訂例外休息時間原因說明')
        return
      }
      let Param = {
        'module':'store',
        'method':'addStoreCustomRestTime',
        'store_id': this.$bus.session.merchant_store_id,
        'resttime_start':this.addData.resttime_date+' '+this.addData.start_time,
        'resttime_end':this.addData.resttime_date+' '+this.addData.end_time,
        'remark':this.addData.remark
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
          vm.$refs.addForm.triggerAlert(data.msg)
          return
        }
        setTimeout(() => {
          vm.searchRestInstance()
        }, 50);
        vm.$bus.fnClosePopup()
        vm.$bus.fnShowInfo("更新成功")
        vm.modalShowAdd = false
      }, this)
    },
  },
  computed: {
    
  },
  created() {
    if (!this.$bus.session.hasOwnProperty('store_service_rule')) {
      // 沒有就抓api寫到session裡,之後讀session
      let Param = {
        'module':'store',
        'method':'getStoreServiceRule',
        'store_id': this.$bus.session.merchant_store_id,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo(data.msg)
            return
          }
        vm.$bus.session.store_service_rule = data.data
        vm.service_minute_unit = parseInt(data.data.service_minute_unit)
      }, this)
    }
  },
  mounted () {
    this.$refs.filterForm.initDefault()
    setTimeout(() => {
      this.searchRestInstance()
      this.addOptions[1].minuteInterval = this.service_minute_unit
      this.addOptions[2].minuteInterval = this.service_minute_unit
      this.$refs.addForm.initDefault()
      
    }, 100);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
